
(function(){
 const root=document.querySelector('[data-airaa-v30-product]');if(!root)return;
 const qty=root.querySelector('[data-airaa-qty]'), minus=root.querySelector('[data-airaa-minus]'), plus=root.querySelector('[data-airaa-plus]');
 const variant=()=>root.querySelector('[name="id"]')?.value;
 if(qty){
  minus?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1));
  plus?.addEventListener('click',()=>qty.value=Math.min(99,Number(qty.value||1)+1));
 }
 const add= root.querySelector('[data-airaa-add]'), buy=root.querySelector('[data-airaa-buy]');
 async function addCart(goCheckout){
  const id=variant();const q=Math.max(1,Number(qty?.value||1));if(!id)return;
  const btn=goCheckout?buy:add;if(btn){btn.disabled=true;btn.textContent='Adding...'}
  try{
   const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:q}]})});
   if(!r.ok)throw new Error('cart');
   if(goCheckout) location.href='/checkout'; else {location.href='/cart'}
  }catch(e){if(btn){btn.disabled=false;btn.textContent=goCheckout?'Buy Now':'Add to Bag'}}
 }
 add?.addEventListener('click',()=>addCart(false));buy?.addEventListener('click',()=>addCart(true));
})();
